import React, { useMemo, useEffect } from 'react';
import { useAuth } from '../utils/Auth';
import { auth } from '../firebase/firebaseConfig';
import { useNavigate, useLocation, Link } from 'react-router';
import SettingsContainer from '../components/SettingsContainer';
import SettingsContainer2 from '../components/SettingsContainer2';
import EnterpriseSettings from '../components/EnterpriseSettings';
import ThemeSelector from '../components/Theming/ThemeSelector';
import ThemeEditor from '../components/Theming/ThemeEditor';
import { useEnterpriseAccount } from '../utils/customHooks';
import './css/Settings.css';

function Settings() {
    const { vcardObj, userObj, route } = useAuth();
    const { pathname, state } = useLocation();
    const entObj = useEnterpriseAccount(userObj);
    const navigate = useNavigate();

    const handleSettingsRouteReturn = useMemo(() => {
        switch (pathname) {
            case '/settings/themes':
                return <ThemeSelector />
            case '/settings/themes/editor':
                return <ThemeEditor />
            case '/settings':
            default:
                return <SettingsContainer2 fromEventRegisterAddPP={state?.toProfilePic} />
        };
    }, [pathname, state]);

    const handleLinksReturn = useMemo(() => {
        switch (pathname) {
            case '/settings/themes':
                return (
                    <div className='settings-links-container'>
                        <Link to='/settings'>Settings</Link>
                        <span>-</span>
                        <div className='settings-current-link'>Theme Selector</div>
                    </div>
                );
            case '/settings/themes/editor':
                return (
                    <div className='settings-links-container'>
                        <Link to='/settings'>Settings</Link>
                        <span>-</span>
                        <Link to='/settings/themes'>Theme Selector</Link>
                        <span>-</span>
                        <div className='settings-current-link'>Theme Editor</div>
                    </div>
                );
            case '/settings':
            default:
                return <></>
        };
    }, [pathname]);

    // Redirects if no authUser
    useEffect(() => {
        if (!auth.currentUser) {
            navigate('/login');
        }
    },[auth.currentUser]);

    // Handles render based on if data has loaded and the value of pageType
    if (userObj && vcardObj && route && pathname) {
        if (userObj?.enterprise_admin && userObj?.enterprise === userObj?.username) {
            navigate('/dashboard');
            return <></>
        };

        return (
            <div className='settings-wrapper'>
                <div className='settings-container'>
                    {userObj.permissions.managed_group === true ?
                        entObj?.hasOwnProperty('uid') ?
                            <EnterpriseSettings userObj={userObj} vcardObj={vcardObj} entObj={entObj} route={route} />
                            :
                            <div className='suspense-loader-wrap'><div className='settings-loader'></div></div>
                        :
                        <>
                            {handleLinksReturn}
                            {handleSettingsRouteReturn}
                        </>
                    }
                </div>
            </div>
        );
    } else {
        return (<></>);
    };
};

export default Settings;